import AuthProvider from '@/auth/core/authProvider'

export default function useToken(axiosIns, jwtOverrideConfig) {
  const auth = new AuthProvider(axiosIns, jwtOverrideConfig)

  return {
    auth,
  }
}
